// Gates github/issues#23429: surface FORBIDDEN permission errors from the relationship mutations as
// an "Access denied" alert, and hide "relates to" candidates the viewer can't triage. Read with
// `useFeatureFlag` (app-payload, repo/org/user gated), not `isFeatureEnabled`.
export const RELATIONSHIP_PERMISSION_FEEDBACK_FEATURE_FLAG = 'issues_relationship_permission_feedback'
